/**
 * Holds information about the outer distance line positions to be
 * used by DistanceWidget and DistanceSystem to place
 * the labels correctly
 */
class DistanceLineCenterComponent {
    constructor(measurements) {
        this.typeId = DistanceLineCenterComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.measurements = measurements;
    }
    eq() {
        return false;
    }
}
DistanceLineCenterComponent.id = 2094;
export default DistanceLineCenterComponent;
//# sourceMappingURL=DistanceLineCenterComponent.js.map